<div
  class="tab-bar"
  [ngClass]="{ 'tab-bar--tab': buttonType === 'tab' }"
  [ngStyle]="outerTabBarStyles | theme"
>
  <div class="tab-bar__scroll" [ngStyle]="scrollStyles | theme">
    @for (tab of tabs; track tab.id; let i = $index) {
      @if (buttonType === "pill") {
        <app-pill-tab-button
          [label]="tab.label"
          [isSelected]="selectedTabIndex === i"
          (clickEvent)="onTabClick(i)"
          class="pill-gap"
        />
      } @else {
        <app-tab-button
          [label]="tab.label"
          [isSelected]="selectedTabIndex === i"
          [pendingCount]="tab.id === resultsTabId ? pendingResultsCount : null"
          [showDot]="tab.id === resultsTabId ? showPendingResultsDot : false"
          (clickEvent)="onTabClick(i)"
        />
      }
    }

    <div
      class="tab-bar__underline"
      [ngClass]="{
        'tab-bar__underline--circle': underlineStyle === 'circle',
        'tab-bar__underline--animate': shouldAnimate,
        'tab-bar__underline--tab': buttonType === 'tab',
        'tab-bar__underline--pill': buttonType === 'pill',
      }"
      [style.transform]="underlineTransform"
      [style.width]="underlineWidth"
      [style.height]="
        underlineStyle === 'circle'
          ? circleRadius
          : buttonType === 'tab'
            ? 'var(--tab-highlight-line-border-width)'
            : 'var(--filter-highlight-line-border-width)'
      "
    ></div>
  </div>

  @if (showBalanceInTab && balance !== undefined) {
    <app-balance-pill class="tab-bar__balance-pill" [balance]="balance" />
  }
</div>
